import { render, staticRenderFns } from "./CourseSearchContainer.vue?vue&type=template&id=10f5b957&scoped=true&"
import script from "./CourseSearchContainer.vue?vue&type=script&lang=js&"
export * from "./CourseSearchContainer.vue?vue&type=script&lang=js&"
import style0 from "./CourseSearchContainer.vue?vue&type=style&index=0&id=10f5b957&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f5b957",
  null
  
)

export default component.exports